module.exports = __webpack_public_path__ + "img/balances-plans.41864f71.svg";